import { TabView, TabPanel } from "primereact/tabview"
import { DateTime } from "luxon"

//SOAR Components
import { UserContext } from "../../../context/userContext"

//Styles
import myStyles from "../../../styles/housing/HousingAllocations.module.css"
import { useContext } from "react"

//HousingAllocations components
import OpenBed from "./OpenBed"
import ActiveRoomParticipantList from "./ActiveRoomOccupantList"
import ActiveRoomPastOccupantList from "./ActiveRoomPastOccupantList"

export function ActiveRoom({
  selectedRoom,
  beds,
  bedOccupants,
  participants,
  participantsLoading,
  setSelectedBed,
  setShowForm,
  onEditStay,
}) {
  const userCtx = useContext(UserContext)

  if (selectedRoom) {
    const nowUtc = DateTime.now().toUTC()

    const editStay = (bedOccupation) => {
      const bed = beds.find((bed) => bed.id === bedOccupation.bedId)

      if (!!bed) {
        setSelectedBed(bed)
        onEditStay(bedOccupation)
      } else {
        userCtx.setNotificationError("Unable to find bed for edit process")
      }
    }

    return (
      <>
        <div className={myStyles.roomContainer}>
          {beds
            ?.filter((x) => x.roomId === selectedRoom.id)
            .map((x, index) => (
              <div key={index}>
                <OpenBed
                  bed={x}
                  bedOccupants={bedOccupants}
                  setSelectedBed={setSelectedBed}
                  setShowForm={setShowForm}
                  onEditStay={onEditStay}
                  participants={participants}
                />{" "}
              </div>
            ))}
        </div>
        <TabView className={myStyles.occupantTabView}>
          <TabPanel header="Active Occupants">
            <ActiveRoomParticipantList
              occupantList={bedOccupants?.filter(
                (x) =>
                  x.bed.roomId === selectedRoom.id &&
                  nowUtc > DateTime.fromISO(x.start, { zone: "utc" }) &&
                  nowUtc < DateTime.fromISO(x.end, { zone: "utc" })
              )}
              participants={participants}
              participantsLoading={participantsLoading}
              onEditClick={editStay}
            />
          </TabPanel>
          <TabPanel header="Future Occupants">
            <ActiveRoomParticipantList
              occupantList={bedOccupants?.filter(
                (x) =>
                  x.bed.roomId === selectedRoom.id &&
                  nowUtc < DateTime.fromISO(x.start, { zone: "utc" })
              )}
              participants={participants}
              participantsLoading={participantsLoading}
              onEditClick={editStay}
            />
          </TabPanel>
          <TabPanel
            header="Past Occupants"
            className={myStyles.pastOccupantTab}
          >
            <ActiveRoomPastOccupantList
              houseId={selectedRoom?.houseId}
              roomId={selectedRoom?.id}
              participants={participants}
              participantsLoading={participantsLoading}
            />
          </TabPanel>
        </TabView>
      </>
    )
  } else {
    return <></>
  }
}
